import React from "react";
import { Marker, Tooltip } from "react-leaflet";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

import { useAppSelector } from "../../redux/hooks";
import { busStationMapIcon } from "../../utils/mapIcons";
import { positionAccuracy } from "../../config";
import variableColors from "../../_App.module.scss";

const { customSecondaryColor, customBgColor } = variableColors;

const ActiveStopPopup = styled.div`
  border: 2px solid ${customSecondaryColor};
  background-color: ${customBgColor};
  font-size: 110%;
  padding: 0.25rem;
  p {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    align-content: center;
    gap: 0.25rem;
    margin-bottom: 0;
  }
`;

const DeviationReportTableMap = (): JSX.Element => {
  const { t } = useTranslation();

  const [deviationReportMapDataFromRedux]: [DeviationReport] = useAppSelector((state: RootState) => [
    state?.deviationReportData?.deviationMapData,
  ]);
  // console.log("deviationReportMapDataFromRedux:", deviationReportMapDataFromRedux);

  const [deviationReportStopInfo, setDeviationReportStopInfo] = React.useState<DeviationReport | null>(null);

  React.useEffect(() => {
    if (deviationReportMapDataFromRedux) {
      setDeviationReportStopInfo(deviationReportMapDataFromRedux);
    }
  }, [deviationReportMapDataFromRedux]);

  return (
    <React.Fragment>
      {/* //* Header component resets stop name */}
      {deviationReportStopInfo && deviationReportStopInfo.stop_name && (
        <Marker
          position={{ lat: deviationReportStopInfo?.loc?.lat!, lng: deviationReportStopInfo?.loc?.lon! }}
          icon={busStationMapIcon}
        >
          <Tooltip permanent={true} direction={"top"}>
            <ActiveStopPopup>
              <p>
                {t("Przystanek")}: <span className="span_bold">{deviationReportStopInfo?.stop_name}</span>
              </p>
              <p>
                {t("Pozycja")}:{" "}
                <span className="span_bold">
                  {deviationReportStopInfo?.loc?.lat.toFixed(positionAccuracy)},{" "}
                  {deviationReportStopInfo?.loc?.lon.toFixed(positionAccuracy)}
                </span>
              </p>
              <p>
                {t("Id")} <span className="span_bold">{deviationReportStopInfo?.id}</span>
              </p>
            </ActiveStopPopup>
          </Tooltip>
        </Marker>
      )}
    </React.Fragment>
  );
};

export default DeviationReportTableMap;
